// src/pages/LoginPage.tsx
import React, { useState } from 'react';
import axios from 'axios';
import { useHistory } from 'react-router-dom';
import { Layout } from '../components/page-layout';

export default function LoginPage() {
  const [email, setEmail] = useState('');
  const [password, setPassword] = useState('');
  const [message, setMessage] = useState('');
  const history = useHistory();

  const handleSubmit = async (e: React.FormEvent) => {
    e.preventDefault();
    try {
      const res = await axios.post('http://localhost:5050/api/auth/login', { email, password });
      setMessage('Login successful!');
      // Save token to localStorage or context here
      localStorage.setItem('token', res.data.token);
      // Redirect to previous page if available
      const redirectPath = localStorage.getItem('postLoginRedirect') || '/';
      localStorage.removeItem('postLoginRedirect');
      history.push(redirectPath);
    } catch (err: any) {
      setMessage(err.response?.data?.error || 'Login failed');
    }
  };

  return (
    <Layout showCommonFooter={true}>
    <form onSubmit={handleSubmit}>
      <h2>Login</h2>
      <input type="email" placeholder="Email" value={email} onChange={e => setEmail(e.target.value)} required />
      <input type="password" placeholder="Password" value={password} onChange={e => setPassword(e.target.value)} required />
      <button type="submit">Login</button>
      {message && <p>{message}</p>}
    </form>
    </Layout>
  );
}